import { mkNode } from './utils';
import { Img } from './image-base';
import { Thumbnail, ThumbnailBase } from './thumbnail-base';

export class ResourceVideo extends ThumbnailBase implements Thumbnail {
    private video: HTMLVideoElement;
    private rows: number;

    public constructor(image: Img, frag: Node, releaseButton = false) {
        const rows = 120;
        let video;
        super(frag, image, releaseButton, () => {
            video = mkNode('video', {
                className: 'thumbnail',
                parent: this.figure,
                style: {visibility: 'hidden', height: rows + 'px'},
                attrib: {controls: 'true', controlsList: 'nodownload', draggable: 'false'}
            });
        });
        this.rows = rows;
        if (!video) {
            throw "Thumbnail video is null";
        }
        this.video = video;
    }

    public async load(buf: ArrayBuffer|null): Promise<void> {
        console.log('IMAGE', this.image);
        const mime = this.image.mime;
        console.log('BUFSIZE', buf?.byteLength);
        if (buf) { // } && mime) {
            const blob = new Blob([buf], {type: mime});
            this.video.src = URL.createObjectURL(blob);
        } else {
            console.error('video steam null');
        }
        this.video.style.visibility = 'visible';
    }

    public async open(): Promise<void> {
        return;
    }

    public destroy(): void {
        super.destroy();
        if (this.video.src) {
            console.log('REVOKE VIDEO URL');
            URL.revokeObjectURL(this.video.src);
            this.video.src = '';
        }
    }
}
